import React, { useState, useEffect } from "react";
import Loader from "./Loader";
import SearchBar from "./SearchBar";
import VideoList from "./VideoList";
import VideoDetail from "./VideoDetail";
import useVideos from "../hooks/useVideos";

const App = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [videos, loading, setLoading, search] = useVideos("Mo Salah");

  useEffect(() => {
    setSelectedVideo(videos[0]);
    console.log("USE EFFECT APP");
    setLoading(false);
  }, [videos, setLoading]);

  return (
    <div className="ui container">
      <SearchBar onSubmit={search} />
      {loading ? (
        <Loader />
      ) : (
        <div className="ui grid">
          <div className="ui row">
            <div className="eleven wide column">
              <VideoDetail video={selectedVideo} />
            </div>
            <div
              className="ui inverted segment five wide column"
              style={{ padding: "15px 5px" }}
            >
              <VideoList onVideoSelect={setSelectedVideo} videos={videos} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default App;
